import React from "react";

class PurifierIcon extends React.Component { 
    render() {
        return (
			<svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M4.69922 23.8996L23.3992 5.09961" stroke="#8A8B8D" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"/>
			<path d="M2 13.2L13.2 2" stroke="#8A8B8D" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"/>
			<path d="M14.9004 27.0008L26.1004 15.8008" stroke="#8A8B8D" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"/>
			</svg>
        )
    }
}

export default PurifierIcon;




